import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';  // ✅ added useLocation
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import JobPostings from '../pages/jobpostings';
import CollaborationsTable from '../pages/collaborations';
import Team from '../pages/team';
import ProductionStatus from '../pages/productionStatus';
import ToolManager from '../pages/ToolManager';
import ProjectInitializer from '../pages/ProjectStarter';
import { baseUrl, R2_PUBLIC_URL } from '../config';
import CommunityManager from '../components/CommunityManager';
import FilmManagement from '../components/filmManagement.jsx';
import PromoteProject from '../components/PromoteProject';
import ErrorBoundary from '../components/ErrorBoundary';
import heroBg from '../assets/img/Productionhousedashboard.jpg';
import settingsBg from '../assets/img/filmmanagement.jpg'; // Company Settings banner (same studio image as Film Management)
import '../styles/productionhouse-dashboard.css';

// ==================== ICONS (inline SVG — no new dependency) ====================
const ICON_PATHS = {
  grid: (<><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></>),
  plusSquare: (<><rect x="3" y="3" width="18" height="18" rx="3" /><line x1="12" y1="8" x2="12" y2="16" /><line x1="8" y1="12" x2="16" y2="12" /></>),
  tool: (<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />),
  briefcase: (<><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></>),
  activity: (<polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />),
  film: (<><rect x="2" y="2" width="20" height="20" rx="2.18" /><line x1="7" y1="2" x2="7" y2="22" /><line x1="17" y1="2" x2="17" y2="22" /><line x1="2" y1="12" x2="22" y2="12" /><line x1="2" y1="7" x2="7" y2="7" /><line x1="2" y1="17" x2="7" y2="17" /><line x1="17" y1="17" x2="22" y2="17" /><line x1="17" y1="7" x2="22" y2="7" /></>),
  link: (<><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" /></>),
  users: (<><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>),
  message: (<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />),
  settings: (<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" /></>),
  star: (<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />),
  tag: (<><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></>),
  chevronRight: (<polyline points="9 18 15 12 9 6" />),
  // ---- Sidebar icons (UI team design) ----
  navFolderPlus: (<><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" /><line x1="12" y1="11" x2="12" y2="17" /><line x1="9" y1="14" x2="15" y2="14" /></>),
  navCogs: (<><g transform="translate(-1.5 3.5) scale(0.72)"><circle cx="12" cy="12" r="3" vectorEffect="non-scaling-stroke" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" vectorEffect="non-scaling-stroke" /></g><g transform="translate(13 0.5) scale(0.42)"><circle cx="12" cy="12" r="3" vectorEffect="non-scaling-stroke" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" vectorEffect="non-scaling-stroke" /></g></>),
  navBriefcasePlus: (<><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /><path d="M2 12h7M15 12h7" /><line x1="12" y1="10" x2="12" y2="16" /><line x1="9.5" y1="13" x2="14.5" y2="13" /></>),
  navTrendBox: (<><rect x="3" y="3" width="18" height="18" rx="4" /><polyline points="7 16 11 12 13 14 17 9" /><polyline points="14 9 17 9 17 12" /><line x1="7" y1="19" x2="7" y2="18" /><line x1="11" y1="19" x2="11" y2="17" /><line x1="15" y1="19" x2="15" y2="17.5" /></>),
  navClapperGear: (<><path d="M3 10v9a2 2 0 0 0 2 2h7" /><path d="M3 10h18v2" /><path d="M3 10l-.6-2.6a1 1 0 0 1 .75-1.2l14.6-3.3a1 1 0 0 1 1.2.75L19.5 6" /><line x1="7" y1="5.4" x2="8.8" y2="9.3" /><line x1="12" y1="4.3" x2="13.8" y2="8.2" /><g transform="translate(12.6 12.6) scale(0.46)"><circle cx="12" cy="12" r="3" vectorEffect="non-scaling-stroke" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" vectorEffect="non-scaling-stroke" /></g></>),
  navUserPlus: (<><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" y1="8" x2="20" y2="14" /><line x1="23" y1="11" x2="17" y2="11" /></>),
  navTeam: (<><circle cx="12" cy="7" r="3" /><circle cx="5" cy="9" r="2" /><circle cx="19" cy="9" r="2" /><path d="M7 21v-2a5 5 0 0 1 10 0v2" /><path d="M1 21v-1a4 4 0 0 1 4-4" /><path d="M23 21v-1a4 4 0 0 0-4-4" /></>),
  navFolderUsers: (<><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" /><circle cx="12" cy="12" r="2" /><path d="M8.5 17.5a3.5 3.5 0 0 1 7 0" /></>),
  navMegaphone: (<><path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z" /><path d="M15.5 8.5a5 5 0 0 1 0 7" /><path d="M18.5 5.5a9 9 0 0 1 0 13" /></>),
  navSearch: (<><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></>),
  upload: (<><polyline points="16 16 12 12 8 16" /><line x1="12" y1="12" x2="12" y2="21" /><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" /></>),
  key: (<><circle cx="7.5" cy="15.5" r="4.5" /><path d="M10.7 12.3L21 2" /><path d="M17 6l3 3" /><path d="M15 8l3 3" /></>),
  hourglass: (<path d="M6 2h12M6 22h12M6 2c0 6 6 6 6 10s-6 4-6 10M18 2c0 6-6 6-6 10s6 4 6 10" />),
  calendar: (<><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></>),
  alert: (<><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></>),
  home: (<><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></>),
  folder: (<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />),
  video: (<><polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" /></>),
  sparkle: (<><path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" /></>),
  fileText: (<><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></>),
  barChart: (<><line x1="12" y1="20" x2="12" y2="10" /><line x1="18" y1="20" x2="18" y2="4" /><line x1="6" y1="20" x2="6" y2="16" /></>),
  user: (<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>),
  checkSquare: (<><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></>),
  edit: (<><path d="M12 20h9" /><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" /></>),
  arrowRight: (<><line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" /></>),
  plus: (<><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>),
};

const Icon = ({ name, size = 18, className = '' }) => (
  <svg
    className={`pd-svg ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICON_PATHS[name]}
  </svg>
);

// Sidebar config — same tab keys and labels as before; "Dashboard" added at top
const SIDEBAR_ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: 'grid' },
  { key: 'create-project', label: 'Create Project', icon: 'navFolderPlus' },
  { key: 'tool-manager', label: 'Tool Manager', icon: 'navCogs' },
  { key: 'job-postings', label: 'Job Postings', icon: 'navBriefcasePlus' },
  { key: 'production-status', label: 'Production Status', icon: 'navTrendBox' },
  { key: 'film-management', label: 'Film Management', icon: 'navClapperGear', chevron: true },
  { key: 'collaborations', label: 'Collaborations', icon: 'navUserPlus' },
  { key: 'team', label: 'Team', icon: 'navTeam' },
  { key: 'community-manager', label: 'Community Manager', icon: 'navFolderUsers' },
  { key: 'company-settings', label: 'Company Settings', icon: 'settings' },
  { key: 'promote-project', label: 'Feature a Project', icon: 'navMegaphone' },
  { key: 'browse-tools', label: 'Browse Tools (Pricing)', icon: 'navSearch', href: '/services' },
];

// Film Management sub-sections (hover flyout on the sidebar item). Ids must match filmManagement.jsx
const FILM_MENU = [
  { id: 'overview', label: 'Overview', icon: 'grid' },
  { id: 'invite-username', label: 'Invite by Username', icon: 'user' },
  { id: 'invite-code', label: 'Invite via Code', icon: 'key' },
  { id: 'pending', label: 'Pending Connections', icon: 'hourglass' },
  { id: 'leaves', label: 'Leave Requests', icon: 'calendar' },
  { id: 'feedback', label: 'Feedback', icon: 'message' },
  { id: 'complaints', label: 'Complaints', icon: 'alert' },
  { id: 'projects', label: 'Project Allocation', icon: 'film' },
];

// ==================== EXISTING COMPONENTS ====================
const Spinner = () => <div className="loader">Loading...</div>;

const ProjectCard = ({ title, status, progress }) => {
  const statusClass = `pd-status-${String(status || '').toLowerCase().replace(/[^a-z]+/g, '-')}`;
  return (
    <div className="pd-project-card">
      <div className="pd-project-top">
        <h3 className="pd-project-title">{title}</h3>
        <span className={`pd-status ${statusClass}`}>{status}</span>
      </div>
      <div className="pd-progress" title={`${progress}%`}>
        <div className="pd-progress-bar" style={{ width: `${progress}%` }} />
      </div>
      <span className="pd-progress-label">{progress}% complete</span>
    </div>
  );
};

const ToolCard = ({ title, description, icon, onClick }) => (
  <div className="pd-tool-card">
    <div className="pd-tool-top">
      <span className="pd-tool-icon"><Icon name={icon || 'sparkle'} size={20} /></span>
      <div>
        <h3 className="pd-tool-title">{title}</h3>
        <p className="pd-tool-desc">{description}</p>
      </div>
    </div>
    <button type="button" className="pd-tool-btn" onClick={onClick}>
      View all <Icon name="arrowRight" size={16} />
    </button>
  </div>
);

const TaskList = ({ tasks, onAddTask }) => {
  const [newTask, setNewTask] = useState('');

  const handleAddTask = () => {
    if (newTask.trim()) {
      onAddTask(newTask);
      setNewTask('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleAddTask();
  };

  return (
    <div className="pd-tasks">
      {tasks.length === 0 && <p className="pd-muted pd-tasks-empty">No tasks for today. Add one below.</p>}
      {tasks.map((task, index) => (
        <label key={index} className="pd-task-row">
          <input type="checkbox" className="pd-checkbox" />
          <span className="pd-task-text">{task}</span>
        </label>
      ))}
      <div className="pd-task-add">
        <input
          type="text"
          value={newTask}
          onChange={(e) => setNewTask(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Add a new task"
          className="pd-input"
        />
        <button type="button" onClick={handleAddTask} className="pd-btn pd-btn-primary">
          <Icon name="plus" size={16} /> Add Task
        </button>
      </div>
    </div>
  );
};

// Kept for reference — no longer rendered on the dashboard (removed per UI proposal; data was hardcoded)
// eslint-disable-next-line no-unused-vars
const NotificationCenter = () => {
  const [notifications, setNotifications] = useState([
    { id: 1, message: "New comment on Project X" },
    { id: 2, message: "Budget approval needed for Project Y" },
    { id: 3, message: "Deadline approaching for Project Z" },
  ]);

  const dismissNotification = (id) => setNotifications(notifications.filter(n => n.id !== id));
  const dismissAllNotifications = () => setNotifications([]);

  return (
    <div className="bg-gray-800 p-4 rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">Notifications</h2>
      {notifications.length === 0 ? (
        <p className="text-gray-400">No new notifications</p>
      ) : (
        <>
          {notifications.map(notif => (
            <div key={notif.id} className="flex justify-between items-center bg-gray-700 p-2 rounded mb-2">
              <span>{notif.message}</span>
              <button onClick={() => dismissNotification(notif.id)} className="text-gray-400 hover:text-white">Dismiss</button>
            </div>
          ))}
          <button onClick={dismissAllNotifications} className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600">
            Dismiss All
          </button>
        </>
      )}
    </div>
  );
};

// Hero banner — fetch + logo upload logic unchanged, only the markup/styling is new
const CompanyInfo = ({ onSetupComplete }) => {
  const [image, setImage] = useState(null);
  const [companyInfo, setCompanyInfo] = useState({ name: 'Production House', description: 'Welcome to your dashboard.' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const response = await fetch(`${baseUrl}/getProductionHouseByOwner`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (response.ok) {
          const data = await response.json();
          setCompanyInfo({ name: data.company_name, description: data.company_description || 'Manage your projects and team efficiently.' });
          if (data.company_logo) setImage(`${baseUrl}/img/${data.company_logo}`);
        } else if (response.status === 404) {
          if (onSetupComplete) onSetupComplete(false);
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyInfo();
  }, [onSetupComplete]);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 10485760) { alert('File is too large. Maximum size is 10MB.'); return; }
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('file_type', 'image');
      formData.append('user_id', 0);
      const uploadResponse = await fetch(`${baseUrl}/upload/direct`, { method: 'POST', body: formData });
      if (uploadResponse.ok) {
        const uploadData = await uploadResponse.json();
        const token = localStorage.getItem("access_token");
        const updateResponse = await fetch(`${baseUrl}/updateProductionHouseLogo`, { method: 'PUT', headers: { 'Authorization': `Bearer ${token}`, 'logo_filename': uploadData.filename } });
        if (updateResponse.ok) { setImage(uploadData.public_url); alert('Logo updated successfully!'); }
      }
    } catch (err) { alert('Failed to upload logo. Please try again.'); }
  };

  const companyName = companyInfo.name || 'Production House';
  const initial = companyName.charAt(0).toUpperCase();

  return (
    <section className="pd-hero">
      <div className="pd-hero-bg" style={{ backgroundImage: `url(${heroBg})` }} />
      <div className="pd-hero-overlay" />
      <div className="pd-hero-content">
        <div className="pd-hero-left">
          <div className="pd-hero-tile"><Icon name="film" size={26} /></div>
          <div className="pd-hero-text">
            {loading ? (
              <>
                <div className="pd-skeleton pd-skeleton-sm" />
                <div className="pd-skeleton pd-skeleton-lg" />
                <div className="pd-skeleton pd-skeleton-md" />
              </>
            ) : (
              <>
                <p className="pd-hero-company">{companyName}</p>
                <h2 className="pd-hero-welcome">Welcome back!</h2>
                <p className="pd-hero-desc">{companyInfo.description}</p>
              </>
            )}
          </div>
        </div>

        <div className="pd-hero-right">
          {image ? (
            <img src={image} alt="Company Logo" className="pd-hero-avatar pd-hero-avatar-img" />
          ) : (
            <div className="pd-hero-avatar">{loading ? '' : initial}</div>
          )}
          <div className="pd-hero-profile">
            <span className="pd-hero-name">{loading ? '' : companyName}</span>
            <input type="file" onChange={handleImageUpload} accept="image/*" className="hidden" id="logo-upload" />
            <label htmlFor="logo-upload" className="pd-hero-change">
              <Icon name="edit" size={13} /> Change logo
            </label>
          </div>
        </div>
      </div>
    </section>
  );
};

// Company Settings — fetch / logo / save logic unchanged; UI rebuilt to the UI team's layout
const CompanySettings = ({ onBack }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    company_name: '', company_description: '', company_email: '', company_phone: '',
    company_website: '', address_line1: '', address_line2: '', city: '', state: '',
    country: '', postal_code: '', founded_year: '', company_size: 'Medium', industry_focus: 'Film',
  });
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const response = await fetch(`${baseUrl}/getProductionHouseByOwner`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (response.ok) {
          const data = await response.json();
          setFormData({
            company_name: data.company_name || '', company_description: data.company_description || '',
            company_email: data.company_email || '', company_phone: data.company_phone || '',
            company_website: data.company_website || '', address_line1: data.address_line1 || '',
            address_line2: data.address_line2 || '', city: data.city || '', state: data.state || '',
            country: data.country || '', postal_code: data.postal_code || '', founded_year: data.founded_year || '',
            company_size: data.company_size || 'Medium', industry_focus: data.industry_focus || 'Film',
          });
          if (data.company_logo) setLogoPreview(`${baseUrl}/img/${data.company_logo}`);
        }
      } catch (err) {
      } finally { setLoading(false); }
    };
    fetchCompanyData();
  }, []);

  const handleChange = (e) => { const { name, value } = e.target; setFormData(prev => ({ ...prev, [name]: value })); };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 10485760) { alert('Logo file is too large. Maximum size is 10MB.'); return; }
    setLogoFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setLogoPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const token = localStorage.getItem("access_token");
      let logoFilename = null;
      if (logoFile) {
        const formDataUpload = new FormData();
        formDataUpload.append('file', logoFile);
        formDataUpload.append('file_type', 'image');
        formDataUpload.append('user_id', 0);
        const uploadResponse = await fetch(`${baseUrl}/upload/direct`, { method: 'POST', body: formDataUpload });
        if (uploadResponse.ok) { const uploadData = await uploadResponse.json(); logoFilename = uploadData.filename; }
      }
      const updateData = { ...formData, founded_year: formData.founded_year ? parseInt(formData.founded_year) : null };
      if (logoFilename) updateData.company_logo = logoFilename;
      const response = await fetch(`${baseUrl}/updateProductionHouse`, { method: 'PUT', headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }, body: JSON.stringify(updateData) });
      if (response.ok) { alert('Company settings updated successfully!'); onBack(); }
      else throw new Error('Update failed');
    } catch (err) { alert('Failed to update company settings. Please try again.'); }
    finally { setSaving(false); }
  };

  const field = (name, label, placeholder, opts = {}) => (
    <div className="cs-field">
      <label htmlFor={`cs-${name}`}>
        {label}{opts.required && <span className="cs-req">*</span>}
        {opts.optional && <span className="cs-optional"> (optional)</span>}
      </label>
      <input
        id={`cs-${name}`}
        type={opts.type || 'text'}
        name={name}
        value={formData[name]}
        onChange={handleChange}
        placeholder={placeholder}
        className="cs-input"
        {...(opts.inputProps || {})}
      />
    </div>
  );

  return (
    <div className="cs-root">
      {/* Banner */}
      <header className="cs-banner">
        <div className="cs-banner-bg" style={{ backgroundImage: `url(${settingsBg})` }} />
        <div className="cs-banner-overlay" />
        <div className="cs-banner-content">
          <h2 className="cs-banner-title">Company Settings</h2>
          <p className="cs-banner-sub">Manage your company details, contact information and profile settings.</p>
        </div>
      </header>

      <section className="cs-card">
        {loading ? (
          <div className="cs-loading">
            <div className="cs-skeleton cs-skeleton--logo" />
            <div className="cs-skeleton" /><div className="cs-skeleton" /><div className="cs-skeleton cs-skeleton--tall" />
          </div>
        ) : (
          <>
            <div className="cs-body">
              {/* Logo */}
              <div className="cs-logo-row">
                {logoPreview ? (
                  <img src={logoPreview} alt="Company logo" className="cs-logo" />
                ) : (
                  <div className="cs-logo cs-logo--initial">{formData.company_name.charAt(0).toUpperCase() || '?'}</div>
                )}
                <div>
                  <p className="cs-logo-title">Company Logo</p>
                  <input id="cs-logo-input" type="file" accept="image/*" onChange={handleLogoChange} className="cs-hidden-input" />
                  <label htmlFor="cs-logo-input" className="cs-upload">
                    <Icon name="upload" size={18} /> {logoFile ? 'Change logo' : 'Upload Logo'}
                  </label>
                  <p className="cs-hint">{logoFile ? logoFile.name : 'PNG or JPG, up to 10MB'}</p>
                </div>
              </div>

              <div className="cs-grid cs-grid--2">
                {field('company_name', 'Company Name', 'Enter your company name', { required: true })}
                {field('company_phone', 'Phone Number', 'Enter your phone number', { type: 'tel' })}
              </div>

              <div className="cs-field">
                <label htmlFor="cs-company_description">Description</label>
                <div className="cs-icon-field">
                  <Icon name="edit" size={15} className="cs-field-icon" />
                  <textarea
                    id="cs-company_description"
                    name="company_description"
                    value={formData.company_description}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Brief overview of your production house..."
                    className="cs-input cs-textarea"
                  />
                </div>
              </div>

              <div className="cs-grid cs-grid--2">
                {field('company_email', 'Email', 'Enter your email address', { type: 'email' })}
                {field('company_website', 'Website', 'Enter your website', { type: 'url' })}
                {field('address_line1', 'Address Line 1', 'Enter your address')}
                {field('address_line2', 'Address Line 2', 'Apartment, suite, landmark', { optional: true })}
              </div>

              <div className="cs-grid cs-grid--4">
                {field('city', 'City', 'Enter your city')}
                {field('state', 'State', 'Enter your state')}
                {field('postal_code', 'Postal Code', 'Enter postal code')}
                {field('country', 'Country', 'Enter your country')}
              </div>

              <div className="cs-grid cs-grid--3">
                {field('founded_year', 'Founded Year', 'Enter the year', { type: 'number', inputProps: { min: 1900, max: new Date().getFullYear() } })}
                <div className="cs-field">
                  <label htmlFor="cs-company_size">Company Size</label>
                  <select id="cs-company_size" name="company_size" value={formData.company_size} onChange={handleChange} className="cs-input cs-select">
                    <option>Small</option><option>Medium</option><option>Large</option><option>Enterprise</option>
                  </select>
                </div>
                <div className="cs-field">
                  <label htmlFor="cs-industry_focus">Industry Focus</label>
                  <select id="cs-industry_focus" name="industry_focus" value={formData.industry_focus} onChange={handleChange} className="cs-input cs-select">
                    <option>Film</option><option>TV</option><option>Documentary</option><option>Music Video</option><option>Commercial</option><option>All</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="cs-footer">
              <button type="button" onClick={onBack} className="cs-btn cs-btn-ghost">Cancel</button>
              <button type="button" onClick={handleSave} disabled={saving} className="cs-btn cs-btn-primary">
                {saving ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </>
        )}
      </section>
    </div>
  );
};

// ==================== MAIN DASHBOARD COMPONENT ====================
const ProductionHouseDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();  // ✅ NEW
  const [setupCompleted, setSetupCompleted] = useState(null);
  const [activeProjects, setActiveProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([
    "Review script changes",
    "Approve location permits",
    "Schedule production meeting",
  ]);
  const [activeTab, setActiveTab] = useState('dashboard');
  // Tool Manager: project currently open inside it (for the breadcrumb) + signal to return to its project list
  const [toolProject, setToolProject] = useState(null);
  const [toolResetSignal, setToolResetSignal] = useState(0);
  // Film Management: active sub-section + hover flyout position
  const [filmSection, setFilmSection] = useState('overview');
  const [filmFlyout, setFilmFlyout] = useState(null); // { top, left }
  const flyoutTimer = useRef(null);
  // Kept (unused) — page-level search strip removed per UI proposal; global header has search
  // eslint-disable-next-line no-unused-vars
  const [searchQuery, setSearchQuery] = useState('');

  // ✅ NEW — read URL params on load (handles bypass redirect + real payment redirect)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    const status = params.get('status');

    if (tab === 'promote-project') {
      setActiveTab('promote-project');
      if (status === 'success') {
        // Clean URL silently — no reload
        window.history.replaceState({}, '', '/production-house/dashboard');
      }
    }
  }, [location.search]);

  const aiTools = [
    { title: "Script Analysis", description: "AI-powered script breakdown", icon: "fileText" },
    { title: "Budget Estimator", description: "Predictive budgeting tool", icon: "barChart" },
    { title: "Casting Recommender", description: "AI casting suggestions", icon: "user" },
  ];

  useEffect(() => {
    const checkSetup = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const response = await fetch(`${baseUrl}/checkProductionHouseSetup`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (response.ok) {
          const data = await response.json();
          const isComplete = data.setup_completed && data.has_company;
          setSetupCompleted(isComplete);
          if (!isComplete) navigate('/production-house-setup');
        } else {
          setSetupCompleted(true);
        }
      } catch (err) {
        setSetupCompleted(true);
      }
    };
    checkSetup();
  }, [navigate]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("access_token");
        const userIdResponse = await fetch(`${baseUrl}/getUserIDByToken`, { headers: { 'Authorization': `Bearer ${token}` } });
        if (userIdResponse.ok) {
          const { user_id } = await userIdResponse.json();
          const projectsResponse = await fetch(`${baseUrl}/getProjectsByUserId`, { headers: { 'user_id': user_id } });
          if (projectsResponse.ok) {
            const projectsData = await projectsResponse.json();
            setActiveProjects((projectsData.projects || []).map(p => ({
              title: p.title,
              status: p.project_status || "Pre-Production",
              progress: p.progress || 0
            })));
          }
        }
      } catch (err) {
      } finally { setLoading(false); }
    };
    if (setupCompleted) fetchProjects();
  }, [setupCompleted]);

  // Kept (unused) — search form removed from the landing screen
  // eslint-disable-next-line no-unused-vars
  const handleSearch = (e) => e.preventDefault();
  const openAITool = (tool) => alert(`${tool.title} - Feature coming soon!`);
  const addTask = (newTask) => setTasks([...tasks, newTask]);

  const handleSidebarClick = (item) => {
    if (item.href) { navigate(item.href); return; }
    if (item.key === 'tool-manager' && activeTab === 'tool-manager') {
      setToolResetSignal(n => n + 1); // already on Tool Manager -> back to its project list
      return;
    }
    setToolProject(null);
    if (item.key === 'film-management') {
      setFilmSection('overview');
      setFilmFlyout(null);
    }
    setActiveTab(item.key);
  };

  // ---- Film Management hover flyout ----
  const openFilmFlyout = (e) => {
    clearTimeout(flyoutTimer.current);
    const r = e.currentTarget.getBoundingClientRect();
    const estHeight = 8 * 42 + 16;
    setFilmFlyout({
      top: Math.max(8, Math.min(r.top, window.innerHeight - estHeight - 8)),
      left: r.right + 6,
    });
  };
  const scheduleCloseFlyout = () => {
    clearTimeout(flyoutTimer.current);
    flyoutTimer.current = setTimeout(() => setFilmFlyout(null), 160);
  };
  const cancelCloseFlyout = () => clearTimeout(flyoutTimer.current);
  const openFilmSection = (id) => {
    setToolProject(null);
    setFilmSection(id);
    setActiveTab('film-management');
    setFilmFlyout(null);
  };

  useEffect(() => {
    if (!filmFlyout) return;
    const close = () => setFilmFlyout(null);
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    document.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
      document.removeEventListener('keydown', onKey);
    };
  }, [filmFlyout]);

  useEffect(() => () => clearTimeout(flyoutTimer.current), []);

  const currentTabLabel = (SIDEBAR_ITEMS.find(i => i.key === activeTab) || {}).label;

  const renderContent = () => {
    switch (activeTab) {
      case 'job-postings': return <JobPostings />;
      case 'collaborations': return <CollaborationsTable />;
      case 'team': return <Team />;
      case 'production-status': return <ProductionStatus />;
      case 'film-management': return <FilmManagement section={filmSection} onSectionChange={setFilmSection} />;
      case 'community-manager': return <CommunityManager />;
      case 'company-settings': return <CompanySettings onBack={() => setActiveTab('dashboard')} />;
      case 'tool-manager': return <ToolManager onProjectChange={setToolProject} resetSignal={toolResetSignal} />;
      case 'promote-project': return <ErrorBoundary><PromoteProject /></ErrorBoundary>;
      case 'create-project': return <ProjectInitializer />;
      default:
        return (
          <div className="pd-dashboard">
            <CompanyInfo onSetupComplete={setSetupCompleted} />

            {/* Active Projects */}
            <section className="pd-card">
              <div className="pd-card-head">
                <div className="pd-card-title">
                  <span className="pd-icon-badge"><Icon name="folder" size={16} /></span>
                  <h2>Active Projects</h2>
                </div>
              </div>

              {loading ? (
                <div className="pd-project-grid">
                  <div className="pd-skeleton pd-skeleton-card" />
                  <div className="pd-skeleton pd-skeleton-card" />
                </div>
              ) : activeProjects.length > 0 ? (
                <div className="pd-project-grid">
                  {activeProjects.map((project, index) => <ProjectCard key={index} {...project} />)}
                </div>
              ) : (
                <div className="pd-empty">
                  <span className="pd-empty-icon"><Icon name="video" size={30} /></span>
                  <p className="pd-empty-title">No active projects yet</p>
                  <p className="pd-empty-sub">Create your first project and start your production journey.</p>
                  <button type="button" onClick={() => setActiveTab('create-project')} className="pd-btn pd-btn-primary">
                    <Icon name="plus" size={16} /> Create Project
                  </button>
                </div>
              )}
            </section>

            {/* AI Tools */}
            <section>
              <div className="pd-section-head">
                <span className="pd-section-icon"><Icon name="sparkle" size={22} /></span>
                <div>
                  <h2 className="pd-section-title">AI Tools</h2>
                  <p className="pd-section-sub">Smart tools to supercharge your production workflow.</p>
                </div>
              </div>
              <div className="pd-tools-grid">
                {aiTools.map((tool, index) => <ToolCard key={index} {...tool} onClick={() => openAITool(tool)} />)}
              </div>
            </section>

            {/* Today's Tasks */}
            <section>
              <div className="pd-section-head">
                <span className="pd-section-icon"><Icon name="checkSquare" size={22} /></span>
                <div>
                  <h2 className="pd-section-title">Today's Tasks</h2>
                  <p className="pd-section-sub">Stay on top of your important tasks.</p>
                </div>
              </div>
              <div className="pd-card">
                <TaskList tasks={tasks} onAddTask={addTask} />
              </div>
            </section>
          </div>
        );
    }
  };

  if (setupCompleted === null) {
    return (
      <>
        <SubNav />
        <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
          <div className="text-center"><Spinner /><p className="mt-4 text-gray-400">Loading dashboard...</p></div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEO
        title="Production House"
        description="Manage your production house operations, projects, and team from ProducerBuddy's production house dashboard."
        url="https://producerbuddy.pilomation.com/production-house"
        robots="noindex, nofollow"
      />
      <SubNav />
      <div className="pd-shell flex min-h-screen bg-gray-900 text-white">
        <aside className="sticky-sidebar pd-sidebar">
          <div className="pd-sidebar-title">Production<br />Dashboard</div>
          <nav aria-label="Production dashboard">
            <ul className="pd-nav">
              {SIDEBAR_ITEMS.map(item => (
                <li
                  key={item.key}
                  onMouseEnter={item.key === 'film-management' ? openFilmFlyout : undefined}
                  onMouseLeave={item.key === 'film-management' ? scheduleCloseFlyout : undefined}
                >
                  <button
                    type="button"
                    onClick={() => handleSidebarClick(item)}
                    className={`pd-nav-item ${activeTab === item.key ? 'is-active' : ''}`}
                    aria-current={activeTab === item.key ? 'page' : undefined}
                  >
                    <Icon name={item.icon} size={20} />
                    <span className="pd-nav-label">{item.label}</span>
                    {item.chevron && <Icon name="chevronRight" size={16} className={`pd-nav-chevron ${item.key === 'film-management' && filmFlyout ? 'is-open' : ''}`} />}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        {/* Film Management hover flyout */}
        {filmFlyout && (
          <div
            className="pd-flyout"
            role="menu"
            aria-label="Film Management"
            style={{ top: filmFlyout.top, left: filmFlyout.left }}
            onMouseEnter={cancelCloseFlyout}
            onMouseLeave={scheduleCloseFlyout}
          >
            {FILM_MENU.map(sub => {
              const isCurrent = activeTab === 'film-management' && filmSection === sub.id;
              return (
                <button
                  key={sub.id}
                  type="button"
                  role="menuitem"
                  className={`pd-flyout-item ${isCurrent ? 'is-active' : ''}`}
                  onClick={() => openFilmSection(sub.id)}
                >
                  <Icon name={sub.icon} size={17} />
                  <span>{sub.label}</span>
                </button>
              );
            })}
          </div>
        )}

        <div className={`flex-1 pd-main ${['create-project', 'tool-manager', 'job-postings', 'production-status'].includes(activeTab) ? 'pd-main--bleed' : ''}`}>
          <nav className="pd-breadcrumb" aria-label="Breadcrumb">
            <button type="button" className="pd-crumb" onClick={() => navigate('/')}>
              <Icon name="home" size={15} /> Home
            </button>
            <Icon name="chevronRight" size={14} className="pd-crumb-sep" />
            {activeTab === 'dashboard' ? (
              <span className="pd-crumb is-current">Production Dashboard</span>
            ) : (
              <>
                <button type="button" className="pd-crumb" onClick={() => { setToolProject(null); setActiveTab('dashboard'); }}>Production Dashboard</button>
                <Icon name="chevronRight" size={14} className="pd-crumb-sep" />
                {activeTab === 'tool-manager' && toolProject ? (
                  <>
                    <button type="button" className="pd-crumb" onClick={() => setToolResetSignal(n => n + 1)}>{currentTabLabel}</button>
                    <Icon name="chevronRight" size={14} className="pd-crumb-sep" />
                    <span className="pd-crumb is-current" title={toolProject.title}>{toolProject.title}</span>
                  </>
                ) : (
                  <span className="pd-crumb is-current">{currentTabLabel}</span>
                )}
              </>
            )}
          </nav>

          <div className="transition-opacity duration-300 notranslate" suppressHydrationWarning={true} translate="no">
            <div key={activeTab} suppressHydrationWarning={true}>
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductionHouseDashboard;